import type { SkeletonShapeProps } from '../types';

import { RectangleStyles } from './Rectangle.styles';

export function Rectangle(props: SkeletonShapeProps) {
	const { className = '', loading = false, rounded = false } = props;

	return <div className={RectangleStyles({ loading, rounded, class: className })} />;
}
